// extracted by mini-css-extract-plugin
export default {"delivery":"Delivery_delivery__dqscg","delivery_card":"Delivery_delivery_card__O1ZGn","card":"Delivery_card__rvfCD"};